export const settingGetters = {
    moduleList: state => state.setting.moduleList,
    categoryList:state => state.setting.categoryList,
    BaseDictionaryList: state => state.setting.BaseDictionaryList,
    BaseDictionaryList_typeDDL: state => state.setting.BaseDictionaryList_typeDDL,
    isMobile: state => state.setting.isMobile,
};